export default {
  themes: [],
  relatedForms: [],
  currentTheme: {
    id: null,
    name: null,
    web_form_theme_font_id: null,
    form_button_background: null,
    form_button_text_colour: null,
    form_answers_text_colour: null,
    form_questions_text_colour: null,
    form_background: null,
    form_background_image_path: null,
    form_background_image_filename: null,
    form_background_image_as_base64_string: null,
  },
  previewTheme: {
    id: null,
    name: null,
    web_form_theme_font_id: null,
    form_button_background: null,
    form_button_text_colour: null,
    form_answers_text_colour: null,
    form_questions_text_colour: null,
    form_background: null,
    form_background_image_path: null,
    form_background_image_filename: null,
    form_background_image_as_base64_string: null,
  },
  currentThemeId: null,
  editableThemeId: null,
};
